import { render, staticRenderFns } from "./SearchBoxIcons.vue?vue&type=template&id=70c7671c&scoped=true&lang=html"
import script from "./SearchBoxIcons.vue?vue&type=script&lang=js"
export * from "./SearchBoxIcons.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxIcons.vue?vue&type=style&index=0&id=70c7671c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7671c",
  null
  
)

export default component.exports